import { Component, Input, OnInit } from '@angular/core';
import { jsPDF } from 'jspdf';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../services/auth.service';
import { UserModel } from '../../models/user.model';
import { ObtenerEstadoCuentaME } from 'src/app/open-api/model/obtenerEstadoCuentaME';
import { CuentaService } from 'src/app/open-api';
import { ObtenerEstadoCuentaMS } from 'src/app/open-api/model/obtenerEstadoCuentaMS';
import { EMPTY_STRING, nowDate } from 'src/app/shared/utils/regular-expresions';

@Component({
  selector: 'app-estado-cuenta',
  templateUrl: './estado-cuenta.component.html',
  styleUrls: ['./estado-cuenta.component.scss'],
})
export class EstadoCuentaComponent implements OnInit {
  @Input() secuencialCuenta?: number;
  @Input() fechaFin?: Date;
  @Input() fechaInicio?: Date;
  usuario?: UserModel;
  estadoCuenta?:ObtenerEstadoCuentaMS;
  activarVistaEstadoCuenta = false;
  currentDate=''

  constructor(
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private cuentaService:CuentaService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.authService.user.subscribe((usuario) => {
      this.usuario = usuario;
    });
    this.ObtenerInformacion();
    this.currentDate = new Date().toString();
  }



  ObtenerInformacion():void{

    const parametro: ObtenerEstadoCuentaME = {
        secuencialCuenta: this.secuencialCuenta ?? 0,
        fechaInicio: new Date(this.fechaInicio?.setHours(0, 0, 0, 0) ?? EMPTY_STRING),
        fechaFin: new Date(this.fechaFin?.setHours(23, 59, 59, 999) ?? EMPTY_STRING)
    };
    this.cuentaService.apiV10CuentaObtenerEstadoCuentaPorSecuencialPost(parametro)
    .subscribe((respuesta)=>{
      this.estadoCuenta = respuesta;
      this.spinner.hide();
    })
  }

  

  Descargar(): void {
    this.spinner.show();

    var titlePage = 'Banca Virtual- Riobamba ---- Estado de Cuenta';
    const doc = new jsPDF('p', 'mm', 'a4');
    const htmlDoc = document.getElementById('cuerpo');
    doc.html(htmlDoc?.innerHTML || '', {
        callback: (doc) => {
          doc.internal.pages.forEach((page) => {
            doc.setFontSize(8);
           
            const footerContent = `Usuario: ${this.usuario?.nombreUsuario} - Fecha ${nowDate()} - Canal: Web-Transaccional `;
            
            doc.setPage(page);
            doc.text(footerContent, 70, doc.internal.pageSize.height - 10);
        });
            // doc.autoPrint();
            doc.save(titlePage+'.pdf')
            this.spinner.hide();
            this.activarVistaEstadoCuenta = true;
            this.activeModal.close();
        },
        width: 170,
        windowWidth: 700,
        autoPaging: true,
        x: 10,
        y: 10,
        margin: [10, 0, 10, 0] ,
        
    });
}


}

